import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';

export default function WhatsAppButton() {
  return (
    <a
      href="https://wa.me/919876543210?text=Hello%20Avivan%20Enterprises%2C%20I%20am%20interested%20in%20your%20FMCG%20distribution%20services."
      className="whatsapp-float"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
    >
      <span className="whatsapp-tooltip">Chat with us</span>
      <FaWhatsapp size={28} />
    </a>
  );
}
